import {
  CreateUserRequest,
  CreateUserResponse,
  EnsureUserProfileRequest,
  EnsureUserProfileResponse,
  FollowUserRequest,
  GetUserFollowingInfoRequest,
  GetUserFollowingInfoResponse,
  GetUserRequest,
  GetUserResponse,
  ListUserFollowersRequest,
  ListUserFollowersResponse,
  ListUserFollowingRequest,
  ListUserFollowingResponse,
  SetActiveOrgRequest,
  SetActiveOrgResponse,
  UnfollowUserRequest,
} from "@/gen/ts/v1/user/user_service_pb";
import { userClient } from "@/lib/connect.client";
import { type ProtoBaseType } from "@/lib/proto/types";
import { Empty } from "@bufbuild/protobuf/wkt";

// We can't import serverUserClient here but it should be the same as userClient
type Client = typeof userClient;

// ===================================================
// ========== Get User ==========
// ===================================================
export function getUserByIdWithClient(client: Client) {
  const fn = async function (
    params: ProtoBaseType<GetUserRequest>,
  ): Promise<GetUserResponse> {
    return client.get({
      ...params,
    });
  };

  return fn;
}

// ===================================================
// ========== Create User ==========
// ===================================================
export function createUserWithClient(client: Client) {
  const fn = async function (
    params: ProtoBaseType<CreateUserRequest>,
  ): Promise<CreateUserResponse> {
    return client.create({
      ...params,
    });
  };
  return fn;
}

// ===================================================
// ========== User Following Info ==========
// ===================================================
export function getUserFollowingInfoWithClient(client: Client) {
  const fn = async function (
    params: ProtoBaseType<GetUserFollowingInfoRequest>,
  ): Promise<GetUserFollowingInfoResponse> {
    return client.getUserFollowingInfo({
      ...params,
    });
  };

  return fn;
}

// ===================================================
// ========== Follow User ==========
// ===================================================
export function followUserWithClient(client: Client) {
  const fn = async function (
    params: ProtoBaseType<FollowUserRequest>,
  ): Promise<Empty> {
    return client.followUser({
      ...params,
    });
  };

  return fn;
}

// ===================================================
// ========== Unfollow User ==========
// ===================================================
export function unfollowUserWithClient(client: Client) {
  const fn = async function (
    params: ProtoBaseType<UnfollowUserRequest>,
  ): Promise<Empty> {
    return client.unfollowUser({
      ...params,
    });
  };

  return fn;
}

// ===================================================
// ========== List User Followers ==========
// ===================================================
export function listUserFollowersWithClient(client: Client) {
  const fn = async function (
    params: ProtoBaseType<ListUserFollowersRequest>,
  ): Promise<ListUserFollowersResponse> {
    return client.listUserFollowers({
      ...params,
    });
  };

  return fn;
}

// ===================================================
// ========== List User Following ==========
// ===================================================

/**
 * Get all users and orgs that the specified user follows
 */
export function listUserFollowingWithClient(client: Client) {
  const fn = async function (
    params: ProtoBaseType<ListUserFollowingRequest>,
  ): Promise<ListUserFollowingResponse> {
    return client.listUserFollowing({
      ...params,
    });
  };

  return fn;
}

// ===================================================
// ========== Set Active Organization ==========
// ===================================================
export function setActiveOrgWithClient(client: Client) {
  const fn = async function (
    params: ProtoBaseType<SetActiveOrgRequest>,
  ): Promise<SetActiveOrgResponse> {
    return client.setActiveOrg({
      ...params,
    });
  };

  return fn;
}

// ===================================================
// ========== Ensure User Profile ==========
// ===================================================
export function ensureUserProfileWithClient(client: Client) {
  const fn = async function (
    params: ProtoBaseType<EnsureUserProfileRequest>,
  ): Promise<EnsureUserProfileResponse> {
    const result = await client.ensureUserProfile({
      ...params,
    });

    return result;
  };

  return fn;
}
